import businessClient from 'src/services/clients/business'
import { IMeta, IMenuCategory } from 'src/common/interfaces/index.js'

const IMenuCategoryListResponse = { meta: IMeta, data: { list: [IMenuCategory] } }
const IMenuCategoryUpsertResponse = { meta: IMeta, data: { upsert: [IMenuCategory] } }
const IMenuCategoryArchiveResponse = { meta: IMeta, data: [IMenuCategory] }

export const menuCategory = {
  /**
   * @param {{store_id: number}} filter
   * @return {IMenuCategoryListResponse}
   */
  list(filter, signal) {
    return businessClient().post('menu/category/portal/list', { filter }, { signal })
  },

  /**
   * @param {IMenuCategory} data
   * @return {IMenuCategoryUpsertResponse}
   */
  upsert(data, signal) {
    return businessClient().post('menu/category/upsert', { data }, { signal })
  },

  /**
   * @param {{id: number}} filter
   * @return {IMenuCategoryArchiveResponse}
   */
  archive(filter, signal) {
    return businessClient().post('menu/category/archive', { filter }, { signal })
  },

  /**
   * @param {{from: number; to: number; menu_id: number;}} filter
   */
  updateOrd(filter, signal) {
    return businessClient().post('menu/category/update-ord', { filter }, { signal })
  },
}
